import omit from 'lodash/omit';
import { CSSProperties } from 'react';

import { Heading } from '~src/components/Typography';
import { Address, AddressWithGeolocation } from '~src/model';
import { formatAddress } from '~src/util';

type AddressStreamerProps = {
  address?: Address | AddressWithGeolocation;
  style?: CSSProperties;
};

export const AddressStreamer = ({ address, style }: AddressStreamerProps) => {
  if (!address) {
    return null;
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', ...style }}>
      <Heading level={3} color='light'>
        Adresse
      </Heading>

      <Heading level={2} style={{ fontWeight: 400 }} color='light'>
        {formatAddress(omit(address, ['id']))}
      </Heading>
    </div>
  );
};
